import { useMutation } from '@tanstack/react-query';
import {
  requestAuthCode,
  type RequestAuthCodeParams,
} from 'shared/src/api/myPageService/phoneAuthPoc/requestAuthCode/requestAuthCode';

export const useRequestAuthCode = () => {
  return useMutation({
    mutationFn: (params: RequestAuthCodeParams) => requestAuthCode(params),
    throwOnError: false,
  });
};
